import React from "react";
import "../css/Pricing.css";

const Pricing2 = () => {
  return (
    <div className="pricing2">

      {/* ---------------- HERO ---------------- */}
      <section className="pricing2-hero">
        <h1>FLEXOR MEMBERSHIPS</h1>
        <p>Engineered for precision, performance, and progress.</p>
      </section>


      {/* ---------------- PRICING TIERS ---------------- */}
      <section className="pricing2-tiers">

        <div className="tier-card basic">
          <h2>B A S E</h2>
          <h3>$29 / month</h3>
          <ul>
            <li>Full Facility Access</li>
            <li>Strength Zone</li>
            <li>Conditioning Floor</li>
            <li>Locker Access</li>
          </ul>
          <button>Select Plan</button>
        </div>

        <div className="tier-card elite">
          <div className="tag">MOST SELECTED</div>
          <h2>E L I T E</h2>
          <h3>$59 / month</h3>
          <ul>
            <li>Everything in BASE</li>
            <li>Mobility Studio</li>
            <li>Unlimited Conditioning Sessions</li>
            <li>Cold / Heat Recovery Zone</li>
          </ul>
          <button>Select Plan</button>
        </div>

        <div className="tier-card apex">
          <h2>A P E X</h2>
          <h3>$99 / month</h3>
          <ul>
            <li>Everything in ELITE</li>
            <li>1:1 Coaching Weekly</li>
            <li>Personalized Programs</li>
            <li>Priority Recovery Bookings</li>
          </ul>
          <button>Select Plan</button>
        </div>

      </section>


      {/* ---------------- COMPARISON GRID ---------------- */}
      <section className="pricing2-compare">
        <h1>Compare Tiers</h1>

        <div className="compare-grid">

          <div className="compare-label">Strength Zone</div>
          <div className="on">✓</div>
          <div className="on">✓</div>
          <div className="on">✓</div>

          <div className="compare-label">Recovery Access</div>
          <div className="off">—</div>
          <div className="on">✓</div>
          <div className="on">✓</div>

          <div className="compare-label">Classes Included</div>
          <div className="off">—</div>
          <div className="on">Unlimited</div>
          <div className="on">Unlimited</div>

          <div className="compare-label">Coaching</div>
          <div className="off">—</div>
          <div className="off">—</div>
          <div className="on">Weekly 1:1</div>

        </div>
      </section>


      {/* ---------------- ADD-ONS ---------------- */}
      <section className="pricing2-addons">
        <h1>Add-Ons</h1>

        <div className="addons-grid">

          <div className="addon-card">
            <h3>Nutrition Blueprint</h3>
            <p>Custom macros, habit coaching, and weekly check-ins.</p>
            <span className="price">$49</span>
          </div>

          <div className="addon-card">
            <h3>Extra PT Session</h3>
            <p>One additional 1:1 elite performance coaching session.</p>
            <span className="price">$60</span>
          </div>

          <div className="addon-card">
            <h3>Mobility Deep Reset</h3>
            <p>Guided flexibility + joint health assessment.</p>
            <span className="price">$35</span>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Pricing2;
